
<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<h2 mat-dialog-title>{{'key-management.export-key-dialog.title' | translate}}</h2>

<mat-dialog-content>

    <div>
        <mat-checkbox [disabled]="!(key.hasPrivateKey || key.hasProtectedKey)" [(ngModel)]="exportPrivate">{{'key-management.export-key-dialog.export-private-key' | translate}}</mat-checkbox>
    </div>

    <div>
        <mat-checkbox [disabled]="!key.hasPrivateKey || !exportPrivate" [(ngModel)]="encrypt">{{'key-management.export-key-dialog.encrypt-private-key' | translate}} <span class="mdi mdi-information" aria-hidden="true" *ngIf="key.hasProtectedKey && exportPrivate" matTooltip="{{'key-management.export-key-dialog.encrypt-info' | translate}}"></span></mat-checkbox>
        <div class="password-inputs">
            <form autocomplete="off">
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'LI_PASSWORD' | translate }}</mat-label>
                        <span style="display: flex;">
                          <input matInput [disabled]="!key.hasPrivateKey || !encrypt" type="password" name="x1"
                                  [(ngModel)]="password" autocomplete="off"
                                  id="newPassInput"
                                  (capsLock)="onCapsLockNewChanged($event)"
                                  (focus)="passwordFocus($event.target?.id)"
                                  (blur)="passwordBlur()"
                                  (input)="tooltipNew?.show()">
                          @if (capsOnNew) {
                            <mat-icon matIconSuffix class="mdi mdi-apple-keyboard-caps caps-on-icon"
                                    #tooltipNew="matTooltip"
                                    matTooltip="{{'CAPS_LOCK_IS_ON' | translate}}" matTooltipPosition="right">
                            </mat-icon>
                          }
                        </span>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'CONFIRM' | translate }}</mat-label>
                        <span style="display: flex;">
                          <input matInput [disabled]="!key.hasPrivateKey || !encrypt" type="password" name="x2"
                                  [(ngModel)]="confirm" autocomplete="off"
                                  id="confirmPassInput"
                                  (capsLock)="onCapsLockConfirmChanged($event)"
                                  (focus)="passwordFocus($event.target?.id)"
                                  (blur)="passwordBlur()"
                                  (input)="tooltipConfirm?.show()">
                          @if (capsOnConfirm) {
                            <mat-icon matIconSuffix class="mdi mdi-apple-keyboard-caps caps-on-icon"
                                      #tooltipConfirm="matTooltip" matTooltip="{{'CAPS_LOCK_IS_ON' | translate}}"
                                      matTooltipPosition="right">
                            </mat-icon>
                          }
                        </span>
                    </mat-form-field>
                </div>
            </form>
        </div>
    </div>

    <div>
        <mat-checkbox [(ngModel)]="exportPublic">{{'key-management.export-key-dialog.export-public-key' | translate}}</mat-checkbox>
    </div>

</mat-dialog-content>

<mat-dialog-actions class="button-wrapper">
    <button mat-raised-button (click)="onClickCancel()">{{'CANCEL' | translate}}</button>
    <button mat-raised-button [disabled]="disableOKButton" (click)="onClickOK()">{{'OK' | translate}}</button>
</mat-dialog-actions>
